// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_ReabrirInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /fechamentos/reabrir/{id}
 *
 * Validates requests to reopen a closed accounting period.
 */
import { registerContract } from './validate'

export interface Fechamentos_ReabrirInput {
motivo: string
}

registerContract('Fechamentos_ReabrirInput', {
  motivo: { type: 'string',  required: true },
})
